import store from '@/store'

export function showPageLoading () {
  store.commit('loading/SET_PAGE_LOADING', true)
}

export function hidePageLoading () {
  store.commit('loading/SET_PAGE_LOADING', false)
}

export function showLoading () {
  store.commit('loading/START_API')
}

export function hideLoading () {
  store.commit('loading/END_API')
}
